(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-shell"] && !Shopify.designMode) return;
  try {
    
  // No celular o menu vira uma fileira rolável: deixa a aba atual visível ao abrir.
  (function () {
    function reveal(scope) {
      (scope || document).querySelectorAll('.ms__item.is-current').forEach(function (item) {
        var list = item.closest('.ms__list');
        if (!list || list.scrollWidth <= list.clientWidth) return;
        list.scrollLeft = Math.max(0, item.offsetLeft - 16);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        reveal();
      });
    } else {
      reveal();
    }
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dopa-closes"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function DopaCloses(root) {
    var track = root.querySelector('[data-track]');
    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (!n) return;
    originals.forEach(function (it, i) { it.setAttribute('data-n', i); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var cur = root.querySelector('[data-cur]'), thumb = root.querySelector('[data-thumb]');
    var lb = root.querySelector('[data-lb]');
    var all = originals, looping = false, index = 0, timer = null, paused = false, dragging = false;

    function padLeft() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function startX() { return originals[0].offsetLeft - padLeft(); }
    function setW() { return originals[0].offsetLeft - all[0].offsetLeft; }
    function nearest() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      all.forEach(function (it, i) {
        var dd = Math.abs(it.offsetLeft - padLeft() - x);
        if (dd < d) { d = dd; best = i; }
      });
      return best;
    }

    // Loop infinito: com mais fotos do que cabem, cria uma cópia da sequência antes e outra depois
    // e, quando a rolagem para fora do meio, volta ao ponto equivalente sem a pessoa perceber.
    function setup() {
      var keep = index;
      Array.prototype.slice.call(track.querySelectorAll('[data-clone]')).forEach(function (c) { c.remove(); });
      all = originals; looping = false;
      var overflow = track.scrollWidth - track.clientWidth > 4;
      root.classList.toggle('no-overflow', !overflow);
      if (overflow && n > 1) {
        var before = document.createDocumentFragment(), after = document.createDocumentFragment();
        originals.forEach(function (it) {
          [before, after].forEach(function (frag) {
            var c = it.cloneNode(true);
            c.setAttribute('data-clone', '');
            c.setAttribute('aria-hidden', 'true');
            c.setAttribute('inert', '');
            frag.appendChild(c);
          });
        });
        track.insertBefore(before, track.firstChild);
        track.appendChild(after);
        all = Array.prototype.slice.call(track.children);
        looping = true;
      }
      track.scrollTo({ left: looping ? startX() + (originals[keep] ? originals[keep].offsetLeft - originals[0].offsetLeft : 0) : 0, behavior: 'auto' });
      update();
    }
    function recenter() {
      if (!looping || dragging) return;
      var x = track.scrollLeft, s = startX(), w = setW();
      if (x < s - 2) track.scrollTo({ left: x + w, behavior: 'auto' });
      else if (x >= s + w - 2) track.scrollTo({ left: x - w, behavior: 'auto' });
    }
    function update() {
      var k = nearest();
      var x = track.scrollLeft, max = track.scrollWidth - track.clientWidth;
      if (!looping && x >= max - 4 && max > 4) k = n - 1;
      index = Number(all[k].getAttribute('data-n')) || 0;
      if (cur) cur.textContent = pad(index + 1);
      if (prev) prev.disabled = !looping && x <= 4;
      if (next) next.disabled = !looping && x >= max - 4;
      if (thumb) {
        thumb.style.width = (100 / n) + '%';
        thumb.style.left = (index * 100 / n) + '%';
      }
    }
    function step(dir) {
      var k = Math.max(0, Math.min(all.length - 1, nearest() + dir));
      var left = Math.min(all[k].offsetLeft - padLeft(), track.scrollWidth - track.clientWidth);
      track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { stop(); step(-1); });
    if (next) next.addEventListener('click', function () { stop(); step(1); });

    var raf = 0, endT = null;
    track.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); });
      clearTimeout(endT);
      endT = setTimeout(recenter, 160);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(endT); recenter(); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); step(-1); }
    });
    var rz = null, lastW = track.clientWidth;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () { if (track.clientWidth !== lastW) { lastW = track.clientWidth; setup(); } }, 150);
    });

    // Arrastar com o mouse no desktop (no toque o rolar nativo já resolve)
    var drag = null, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, s: track.scrollLeft }; moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!moved && Math.abs(dx) > 6) { moved = true; dragging = true; track.classList.add('is-grabbing'); stop(); }
      if (moved) track.scrollLeft = drag.s - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      var wasMoved = moved; drag = null;
      if (wasMoved) {
        dragging = false;
        track.classList.remove('is-grabbing');
        step(0);
        setTimeout(function () { moved = false; }, 0);
      }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    // Autoplay (só se ligado no editor): pausa com mouse em cima, foco, toque ou fora da tela
    var ap = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function startAp() {
      if (!ap || reduce || timer || !looping) return;
      timer = setInterval(function () {
        if (paused || (lb && lb.open)) return;
        step(1);
      }, ap);
    }
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', stop, { passive: true });

    // Entrada suave dos cards e autoplay só quando a seção aparece
    if ('IntersectionObserver' in window) {
      if (!reduce) root.classList.add('js-reveal');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { root.classList.add('is-in'); startAp(); } else { stop(); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    // Ampliar o close em tela cheia: só no celular e no tablet; no desktop o clique não abre nada
    if (desktop.matches) {
      root.classList.add('is-desktop');
      originals.forEach(function (it) {
        var b = it.querySelector('[data-open]');
        if (b) { b.setAttribute('tabindex', '-1'); b.removeAttribute('aria-label'); }
      });
    } else if (lb && typeof lb.showModal === 'function') {
      var frame = lb.querySelector('[data-lb-frame]'), img = lb.querySelector('[data-lb-img]');
      var lbIdx = lb.querySelector('[data-lb-idx]'), lbName = lb.querySelector('[data-lb-name]'), lbDesc = lb.querySelector('[data-lb-desc]');
      var lbCur = lb.querySelector('[data-lb-cur]'), open = 0;
      var show = function (i) {
        open = (i + n) % n;
        var it = originals[open], src = it.querySelector('img');
        frame.classList.remove('is-zoomed');
        img.src = it.getAttribute('data-full') || (src && src.currentSrc) || '';
        img.alt = src ? src.alt : '';
        lbIdx.textContent = pad(open + 1);
        var nm = it.querySelector('.dopa-closes__name');
        lbName.textContent = nm ? nm.textContent : '';
        var d = it.querySelector('.dopa-closes__desc');
        lbDesc.innerHTML = d ? d.innerHTML : '';
        if (lbCur) lbCur.textContent = pad(open + 1);
      };
      track.addEventListener('click', function (e) {
        var b = e.target.closest('[data-open]');
        if (!b) return;
        var li = b.closest('[data-n]');
        stop(); show(Number(li.getAttribute('data-n')) || 0); lb.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      lb.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
      lb.querySelector('[data-lb-close]').addEventListener('click', function () { lb.close(); });
      var lp = lb.querySelector('[data-lb-prev]'), ln = lb.querySelector('[data-lb-next]');
      if (lp) { lp.hidden = n < 2; lp.addEventListener('click', function () { show(open - 1); }); }
      if (ln) { ln.hidden = n < 2; ln.addEventListener('click', function () { show(open + 1); }); }
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(open + 1);
        if (e.key === 'ArrowLeft') show(open - 1);
      });
      frame.addEventListener('click', function (e) {
        var r = frame.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        frame.classList.toggle('is-zoomed');
      });
      var tx = null;
      lb.addEventListener('touchstart', function (e) { tx = frame.classList.contains('is-zoomed') ? null : e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx; tx = null;
        if (Math.abs(dx) > 45 && n > 1) show(open + (dx < 0 ? 1 : -1));
      });
    }

    setup();
    if (document.readyState !== 'complete') window.addEventListener('load', function () { lastW = track.clientWidth; setup(); });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dopa-closes]:not([data-ready])'), function (r) {
      r.setAttribute('data-ready', '');
      DopaCloses(r);
    });
  }
  window.DopaClosesInit = initAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dopa-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(m) {
      if (m.getAttribute('data-mq-ready') === 'true') return;
      m.setAttribute('data-mq-ready', 'true');
      var track = m.querySelector('.dopa-marquee__track');
      var group = m.querySelector('.dopa-marquee__group');
      function build() {
        track.querySelectorAll('.dopa-marquee__group:not(:first-child)').forEach(function (g) {
          g.remove();
        });
        var w = group.getBoundingClientRect().width;
        if (!w) return;
        var copies = Math.ceil(m.clientWidth / w) + 1;
        for (var i = 0; i < copies; i++) {
          track.appendChild(group.cloneNode(true));
        }
        var shift = w;
        track.style.setProperty('--mq-shift', shift + 'px');
        track.style.setProperty('--mq-dur', shift / (Number(m.dataset.speed) || 80) + 's');
      }
      build();
      // A largura do texto muda quando a fonte do tema termina de carregar; sem refazer, a volta pula.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(build, 150);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.dopa-marquee').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dopa-specs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  var uid = 0;
  function el(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function DopaRadar(root) {
    var data = JSON.parse(root.querySelector('[data-radar-json]').textContent);
    var attrs = data.attrs.filter(function (a) { return a.v != null; });
    function ov(o, k) { var x = o.vals[k]; return x == null ? '\u2013' : x; }
    if (attrs.length < 3) { root.hidden = true; return; }
    var n = attrs.length, R = 90, id = 'dr' + (++uid);
    var svg = root.querySelector('svg');
    var chips = root.querySelector('[data-radar-chips]');
    var note = root.querySelector('[data-radar-note]');
    var go = root.querySelector('[data-radar-go]');
    var cmp = null, meVals = attrs.map(function () { return 0; }), cmpVals = attrs.map(function () { return 0; });
    svg.setAttribute('viewBox', '-210 -134 420 284');
    svg.innerHTML = '';
    var defs = el('defs', {}, svg);
    var g = el('linearGradient', { id: id + 'g', x1: '0', y1: '0', x2: '1', y2: '1' }, defs);
    [['0', '--rg1'], ['.5', '--rg2'], ['1', '--rg3']].forEach(function (s) {
      el('stop', { offset: s[0], style: 'stop-color:var(' + s[1] + ');stop-opacity:var(--rgo)' }, g);
    });
    function pt(i, v) {
      var a = -Math.PI / 2 + i * 2 * Math.PI / n;
      return [Math.cos(a) * R * v / 5, Math.sin(a) * R * v / 5];
    }
    var grid = el('g', { 'class': 'dr-grid' }, svg);
    for (var l = 1; l <= 5; l++) {
      el('polygon', { points: attrs.map(function (_, i) { return pt(i, l).join(','); }).join(' ') }, grid);
    }
    attrs.forEach(function (_, i) { var p = pt(i, 5); el('line', { x1: 0, y1: 0, x2: p[0], y2: p[1] }, grid); });
    var cmpPoly = el('polygon', { 'class': 'dr-cmp', points: '' }, svg);
    var mePoly = el('polygon', { 'class': 'dr-me', fill: 'url(#' + id + 'g)', points: '' }, svg);
    var dots = el('g', { 'class': 'dr-dots' }, svg);
    var labels = el('g', { 'class': 'dr-labels' }, svg);
    var valTexts = [];
    attrs.forEach(function (a, i) {
      var p = pt(i, 6.15), anchor = Math.abs(p[0]) < 4 ? 'middle' : (p[0] > 0 ? 'start' : 'end');
      var y = p[1] < -40 ? p[1] - 14 : (p[1] > 40 ? p[1] + 6 : p[1] - 6);
      var grp = el('g', { 'class': 'dr-axis', tabindex: '0', role: 'button', 'aria-label': a.label }, labels);
      el('text', { x: p[0], y: y, 'text-anchor': anchor, 'class': 'dr-name' }, grp).textContent = a.label;
      var t = el('text', { x: p[0], y: y + 17, 'text-anchor': anchor, 'class': 'dr-val' }, grp);
      valTexts.push(t);
      grp.addEventListener('click', function () { showNote(i); });
      grp.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showNote(i); } });
    });
    function paintVals() {
      valTexts.forEach(function (t, i) {
        t.innerHTML = '';
        // Sempre "nota / outra": sem comparação a outra é um tracinho
        var a = el('tspan', { 'class': 'dr-val-me' }, t); a.textContent = attrs[i].v;
        var s = el('tspan', { 'class': 'dr-val-sep' }, t); s.textContent = ' / ';
        var b = el('tspan', { 'class': cmp ? 'dr-val-cmp' : 'dr-val-none' }, t); b.textContent = cmp ? ov(cmp, attrs[i].key) : '–';
      });
    }
    function draw() {
      mePoly.setAttribute('points', meVals.map(function (v, i) { return pt(i, v).join(','); }).join(' '));
      cmpPoly.setAttribute('points', cmpVals.map(function (v, i) { return pt(i, v).join(','); }).join(' '));
      dots.innerHTML = '';
      meVals.forEach(function (v, i) { var p = pt(i, v); el('circle', { cx: p[0], cy: p[1], r: 3 }, dots); });
    }
    function tween(fromMe, toMe, fromCmp, toCmp) {
      var t0 = null, dur = reduce ? 0 : 650;
      function frame(now) {
        if (t0 === null) t0 = now;
        var k = dur ? Math.min(1, (now - t0) / dur) : 1, e = 1 - Math.pow(1 - k, 3);
        meVals = fromMe.map(function (s, i) { return s + (toMe[i] - s) * e; });
        cmpVals = fromCmp.map(function (s, i) { return s + (toCmp[i] - s) * e; });
        draw();
        if (k < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }
    function target(o) { return attrs.map(function (a) { return o ? (Number(o.vals[a.key]) || 0) : 0; }); }
    function showNote(i) {
      var a = attrs[i];
      var txt = '<b>' + a.label + '</b> ' + data.title + ' ' + a.v + '/5';
      if (cmp) txt += ' · ' + cmp.title + ' ' + ov(cmp, a.key) + '/5';
      if (a.desc) txt += '. ' + a.desc;
      note.innerHTML = txt;
    }
    function setCmp(o) {
      var from = cmpVals.slice();
      cmp = o;
      root.classList.toggle('is-comparing', !!o);
      if (go) {
        go.hidden = !(o && o.url);
        if (o && o.url) {
          go.href = o.url;
          go.querySelector('[data-radar-go-txt]').textContent = (data.go_label || 'Ir para') + ' ' + o.title;
        }
      }
      Array.prototype.forEach.call(chips.querySelectorAll('button'), function (b, i) {
        b.setAttribute('aria-pressed', o && data.others[i] === o ? 'true' : 'false');
      });
      paintVals();
      note.textContent = o ? data.note_cmp.replace('%s', o.title) : data.note_idle;
      tween(meVals.slice(), meVals.slice(), from, o ? target(o) : attrs.map(function () { return 0; }));
    }
    chips.innerHTML = '';
    if (data.others && data.others.length) {
      data.others.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dr-chip'; b.setAttribute('aria-pressed', 'false');
        b.textContent = o.title;
        b.addEventListener('click', function () { setCmp(cmp === o ? null : o); });
        chips.appendChild(b);
      });
      chips.parentNode.hidden = false;
    } else {
      chips.parentNode.hidden = true;
    }
    paintVals();
    note.textContent = data.note_idle;
    var meT = attrs.map(function (a) { return Number(a.v); });
    function start() { tween(meVals.slice(), meT, cmpVals.slice(), cmpVals.slice()); }
    if ('IntersectionObserver' in window && !reduce) {
      draw();
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(svg);
    } else { meVals = meT; draw(); }
  }
  window.DopaRadar = DopaRadar;
  // Fase 1: vídeo do bloco só baixa e toca perto da tela; pausa quando sai (antes baixava inteiro ao abrir a página)
  function lazyVideos(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.dopa-specs__video video:not([data-lv])'), function (v) {
      v.setAttribute('data-lv', '');
      v.muted = true;
      if (v.dataset.poster) {
        if ('IntersectionObserver' in window) {
          var pio = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) { v.poster = v.dataset.poster; pio.disconnect(); } });
          }, { rootMargin: '100% 0px' });
          pio.observe(v);
        } else { v.poster = v.dataset.poster; }
      }
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if (!('IntersectionObserver' in window)) { play(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(); else if (!v.paused) v.pause(); });
      }, { threshold: 0.15 });
      io.observe(v);
    });
  }
  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dopa-radar]:not([data-ready])'), function (r) {
      r.setAttribute('data-ready', '');
      DopaRadar(r);
    });
    lazyVideos(scope);
  }
  window.DopaRadarInit = initAll;
  // O vídeo fixa logo abaixo do menu do topo (que é fixo e muda de altura quando a faixa de aviso some ao rolar)
  var lastTop = -1, stRaf = 0;
  function stickyTop() {
    stRaf = 0;
    var h = document.getElementById('header') || document.querySelector('.header-section');
    var b = h ? h.getBoundingClientRect().bottom : 0;
    var t = Math.round(Math.max(0, Math.min(b, 240)) + 20);
    if (t === lastTop) return;
    lastTop = t;
    Array.prototype.forEach.call(document.querySelectorAll('.dopa-specs'), function (s) { s.style.setProperty('--ds-sticky-top', t + 'px'); });
  }
  function queueSticky() { if (!stRaf) stRaf = requestAnimationFrame(stickyTop); }
  stickyTop();
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);
  window.addEventListener('load', stickyTop);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var isMoney = { gastoDopa: 1, gastoCentauro: 1, gastoZ2: 1, gastoOutlive: 1, gastoZerezes: 1, gastoPacco: 1, gastoV3rso: 1 };
    var unit = { pedidosAno: ['pedido', 'pedidos'], dayUsesVoturuna: ['day use', 'day uses'] };

    function ensureCalc(sec, done) {
      if (window.DopaMembershipCalc) return done(true);
      var src = sec.getAttribute('data-calc-src');
      if (!src) return done(false);
      var tag = document.createElement('script');
      tag.src = src;
      tag.onload = function () {
        done(!!window.DopaMembershipCalc);
      };
      tag.onerror = function () {
        done(false);
      };
      document.head.appendChild(tag);
    }

    function init(sec) {
      if (sec.getAttribute('data-mc-ready') === 'true') return;
      sec.setAttribute('data-mc-ready', 'true');

      var C;
      try {
        C = JSON.parse(sec.getAttribute('data-config') || '{}');
      } catch (e) {
        C = null;
      }

      var q = function (name) {
        return sec.querySelector('[data-mc="' + name + '"]');
      };
      var inputs = {};
      var ranges = sec.querySelectorAll('input[type=range]');
      var switches = sec.querySelectorAll('[role=switch][data-key]');
      var compute, money;
      var pinEl = q('pin');
      var lastLines = '';

      // Escreve só quando muda: menos trabalho por quadro enquanto o dedo arrasta o controle.
      function setText(el, t) {
        if (el && el.textContent !== t) el.textContent = t;
      }
      function setHTML(el, h) {
        if (el && el.innerHTML !== h) el.innerHTML = h;
      }

      // Maior valor possível de cada linha (controle no máximo, alternância ligada), para a coluna de
      // valor nascer com a largura final.
      function setGhosts() {
        read();
        function gainGhost(k, test) {
          var g = sec.querySelector('[data-mc-out="' + k + '"]');
          if (!g) return;
          var l = compute(test, C).linhas.filter(function (x) {
            return x.chave === k;
          })[0];
          if (l) g.setAttribute('data-ghost', '+ ' + money(l.valor));
        }
        ranges.forEach(function (r) {
          var k = r.dataset.key,
            mx = Number(r.max);
          var o = sec.querySelector('[data-mc-value="' + k + '"]');
          if (o) o.setAttribute('data-ghost', isMoney[k] ? money(mx) : String(mx));
          var test = Object.assign({}, inputs);
          test[k] = mx;
          gainGhost(k, test);
        });
        switches.forEach(function (sw) {
          var test = Object.assign({}, inputs);
          test[sw.dataset.key] = true;
          gainGhost(sw.dataset.key, test);
        });
      }

      // Cola a faixa fixa embaixo do menu flutuante do tema (pílula branca do cabeçalho).
      var pinGeo = '';
      function placePin() {
        if (!pinEl || getComputedStyle(pinEl).display === 'none') return;
        var bar = document.querySelector('.mms-header__row') || document.querySelector('#header');
        if (!bar) return;
        var r = bar.getBoundingClientRect();
        if (!r.height || r.bottom <= 0 || r.bottom > 160) return;
        var inner = sec.querySelector('.mc__inner').getBoundingClientRect();
        var rad = parseFloat(getComputedStyle(bar).borderBottomLeftRadius) || 0;
        var geo = [Math.round(r.bottom), Math.round(r.left - inner.left), Math.round(inner.right - r.right), Math.round(rad)].join(',');
        if (geo === pinGeo) return;
        pinGeo = geo;
        sec.style.setProperty('--mc-pin-top', Math.round(r.bottom) + 'px');
        sec.style.setProperty('--mc-pin-ml', Math.round(r.left - inner.left) + 'px');
        sec.style.setProperty('--mc-pin-mr', Math.round(inner.right - r.right) + 'px');
        sec.style.setProperty('--mc-pin-radius', Math.round(rad) + 'px');
        sec.style.setProperty('--mc-pin-tuck', Math.round(rad) + 'px');
      }

      function read() {
        ranges.forEach(function (r) {
          inputs[r.dataset.key] = Number(r.value);
        });
        switches.forEach(function (s) {
          inputs[s.dataset.key] = s.getAttribute('aria-checked') === 'true';
        });
      }

      function fill(r) {
        var p = ((r.value - r.min) / (r.max - r.min)) * 100;
        r.style.setProperty('--fill', p + '%');
      }

      function render() {
        read();
        var R = compute(inputs, C);
        ranges.forEach(function (r) {
          var k = r.dataset.key,
            v = Number(r.value);
          var txt = isMoney[k] ? money(v) : String(v);
          setText(sec.querySelector('[data-mc-value="' + k + '"]'), txt);
          r.setAttribute('aria-valuetext', isMoney[k] ? txt : v + ' ' + (unit[k] ? unit[k][v === 1 ? 0 : 1] : ''));
          fill(r);
        });
        ['usaRunna', 'usaR3'].forEach(function (k) {
          setText(sec.querySelector('[data-mc-switch-text="' + k + '"]'), inputs[k] ? 'Sim' : 'Não');
        });
        setText(q('giftDesc'), inputs.incluiGift
          ? 'Chega no seu e-mail e nunca expira. Toque para tirar da conta.'
          : 'Fora da conta. Toque para incluir de novo.');
        setText(q('meiaDesc'), inputs.incluiMeia
          ? 'Um design novo por ano, entregue na sua casa. Toque para tirar da conta.'
          : 'Fora da conta. Toque para incluir de novo.');
        var byKey = {};
        R.linhas.forEach(function (l) {
          byKey[l.chave] = l;
        });
        Object.keys(byKey).forEach(function (k) {
          var o = sec.querySelector('[data-mc-out="' + k + '"]');
          if (!o) return;
          var l = byKey[k];
          setText(o, '+ ' + money(l.valor));
          o.classList.toggle('is-zero', !l.on);
        });
        // Extrato montado como texto e trocado só quando muda (antes era refeito do zero a cada movimento).
        var html = '';
        var cat = '';
        R.linhas.forEach(function (l) {
          if (!l.on && l.cat === 'Parceiros') return;
          if (l.cat !== cat) {
            cat = l.cat;
            html += '<li class="ledger__cat' + (cat === 'Parceiros' ? ' is-partner' : '') + '">' + cat + '</li>';
          }
          html +=
            '<li class="ledger__row' +
            (l.on ? '' : ' is-off') +
            '"><div><div class="ledger__name">' +
            l.rotulo +
            '</div><div class="ledger__how num">' +
            l.como +
            '</div></div><div class="ledger__val num">' +
            money(l.valor) +
            '</div></li>';
        });
        if (
          !R.linhas.some(function (l) {
            return l.cat === 'Parceiros' && l.on;
          })
        ) {
          html +=
            '<li class="ledger__cat is-partner">Parceiros</li><li class="ledger__row is-off"><div><div class="ledger__name">Nenhum parceiro em uso</div><div class="ledger__how">Ligue um acima para ver o valor aqui</div></div><div class="ledger__val num">R$ 0</div></li>';
        }
        if (html !== lastLines) {
          lastLines = html;
          q('lines').innerHTML = html;
        }
        setText(q('tBen'), money(R.valorAnual));
        setText(q('tCost'), '− ' + money(R.custo));
        var net = q('net'),
          neg = R.saldo < 0;
        net.classList.toggle('is-neg', neg);
        sec.querySelector('.ledger').classList.toggle('is-neg', neg);
        var kTxt = 'Retorno líquido';
        var vTxt = (neg ? '− ' : '+ ') + money(Math.abs(R.saldo));
        setText(q('netK'), kTxt);
        setText(q('netV'), vTxt);
        setText(q('netS'), neg
          ? money(R.valorAnual) + ' em benefícios por ' + money(R.custo) + '. Faltam ' + money(-R.saldo) + ' para o membership se pagar.'
          : money(R.valorAnual) + ' em benefícios por ' + money(R.custo) + '. O membership se paga e ainda gera ' + money(R.saldo) + '.');
        var pct = R.custo > 0 ? Math.min(100, (R.valorAnual / R.custo) * 100) : 100;
        q('barFill').style.width = pct + '%';
        setHTML(q('barCapL'), '<b>' + money(R.valorAnual) + '</b> em benefícios');
        setHTML(q('barCapR'), neg ? 'faltam <b>' + money(-R.saldo) + '</b>' : '<b>' + money(R.custo) + '</b> · se pagou');
        pinEl.classList.toggle('is-neg', neg);
        setText(q('pinVal'), (neg ? '− ' : '+ ') + money(Math.abs(R.saldo)));
      }

      // O botão faz o mesmo que a barra fixa SEJA MEMBRO (bloco do Sidekick, só reaproveitamos o clique).
      // Sem a barra, ou com outro link no editor, o link segue normalmente (#assinar é a reserva).
      var cta = q('cta');
      if (cta) {
        cta.addEventListener('click', function (event) {
          if (cta.getAttribute('href') !== '#assinar') return;
          var barButton = document.querySelector('button[class*="ai-sticky-product-card__button"]');
          if (!barButton || barButton.disabled) return;
          event.preventDefault();
          barButton.click();
        });
      }

      ensureCalc(sec, function (ok) {
        if (!ok || !C) {
          console.error('Calculadora do Membership: membership-calc.js não carregou ou a configuração é inválida');
          sec.classList.add('mc--no-calc');
          return;
        }
        compute = window.DopaMembershipCalc.compute;
        money = window.DopaMembershipCalc.money;

        // Um cálculo por quadro, no máximo, enquanto o dedo arrasta.
        var queued = false;
        function schedule() {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            render();
          });
        }
        ranges.forEach(function (r) {
          r.addEventListener('input', schedule);
          // No celular, o controle não fica com o foco depois que o dedo sai: um campo focado faz o
          // iPhone reajustar a rolagem para mantê-lo à vista, o que dava o tremido ao rolar a página.
          r.addEventListener('touchend', function () {
            setTimeout(function () {
              r.blur();
            }, 0);
          }, { passive: true });
        });
        switches.forEach(function (s) {
          s.addEventListener('click', function () {
            s.setAttribute('aria-checked', s.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
            render();
          });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (es) {
              pinEl.style.visibility = es[0].isIntersecting ? 'hidden' : 'visible';
            },
            { threshold: 0.05 }
          ).observe(sec.querySelector('.ledger'));
        }
        setGhosts();
        render();
        placePin();
        var pinTick = false;
        function onScrollPin() {
          if (pinTick) return;
          pinTick = true;
          requestAnimationFrame(function () {
            pinTick = false;
            placePin();
          });
        }
        window.addEventListener('scroll', onScrollPin, { passive: true });
        window.addEventListener('resize', onScrollPin, { passive: true });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.mc').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-manual-shell"] && !Shopify.designMode) return;
  try {
    
  // No celular o menu vira uma fileira rolável: deixa a aba atual visível ao abrir.
  (function () {
    function reveal(scope) {
      (scope || document).querySelectorAll('.ms__item.is-current').forEach(function (item) {
        var list = item.closest('.ms__list');
        if (!list || list.scrollWidth <= list.clientWidth) return;
        list.scrollLeft = Math.max(0, item.offsetLeft - 16);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        reveal();
      });
    } else {
      reveal();
    }
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-partners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(pd) {
      if (pd.getAttribute('data-pd-ready') === 'true') return;
      pd.setAttribute('data-pd-ready', 'true');
      var panels = Array.prototype.slice.call(pd.querySelectorAll('.pd__panel'));
      if (!panels.length) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobile = window.matchMedia('(max-width: 900px)');

      // Fonte do vídeo pelo tamanho da tela; só é chamada quando o painel entra na tela.
      function src(v) {
        var want = mobile.matches ? v.dataset.mobile : v.dataset.desktop;
        var poster = mobile.matches ? v.dataset.posterMobile : v.dataset.posterDesktop;
        if (poster && v.getAttribute('poster') !== poster) v.setAttribute('poster', poster);
        if (want && v.getAttribute('src') !== want) {
          v.setAttribute('src', want);
          v.load();
        }
      }
      // Imagem de espera certa para o tamanho da tela já na abertura (o vídeo só carrega ao aparecer).
      function posters() {
        panels.forEach(function (p) {
          var v = p.querySelector('video');
          var poster = mobile.matches ? v.dataset.posterMobile : v.dataset.posterDesktop;
          if (poster && v.getAttribute('poster') !== poster) v.setAttribute('poster', poster);
        });
      }
      function srcVisiveis() {
        posters();
        panels.forEach(function (p) {
          var v = p.querySelector('video');
          if (v.getAttribute('src')) src(v);
        });
      }
      function activate(i) {
        panels.forEach(function (p, k) {
          p.classList.toggle('is-active', k === i);
        });
      }
      panels.forEach(function (p, k) {
        p.addEventListener('mouseenter', function () {
          if (!mobile.matches) activate(k);
        });
        p.addEventListener('focus', function () {
          activate(k);
        });
        p.addEventListener('click', function () {
          activate(k);
        });
      });

      var counted = false;
      function count() {
        if (counted || reduced) return;
        counted = true;
        pd.querySelectorAll('[data-count]').forEach(function (el) {
          var to = Number(el.dataset.count),
            t0 = performance.now();
          (function step(t) {
            var k = Math.min(1, (t - t0) / 900);
            el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
            if (k < 1) requestAnimationFrame(step);
          })(t0);
        });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (es) {
            es.forEach(function (e) {
              var v = e.target.querySelector('video');
              if (e.isIntersecting) {
                src(v);
                if (!reduced) v.play().catch(function () {});
                count();
              } else {
                v.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        panels.forEach(function (p) {
          io.observe(p);
        });
      } else {
        panels.forEach(function (p) {
          src(p.querySelector('video'));
        });
      }
      posters();
      if (mobile.addEventListener) mobile.addEventListener('change', srcVisiveis);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.pd').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-perks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(pk) {
      if (pk.getAttribute('data-pk-ready') === 'true') return;
      pk.setAttribute('data-pk-ready', 'true');
      var rows = Array.prototype.slice.call(pk.querySelectorAll('.pk__row'));
      var cards = Array.prototype.slice.call(pk.querySelectorAll('.pk__card'));
      var stage = pk.querySelector('.pk__stage');
      var n = rows.length;
      if (!n) return;
      var cur = 0,
        reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        hover = window.matchMedia('(hover: hover)').matches;
      function show(i) {
        cur = (i + n) % n;
        rows.forEach(function (r, k) {
          r.classList.toggle('is-active', k === cur);
        });
        cards.forEach(function (c) {
          var k = Number(c.dataset.i);
          var d = (k - cur + n) % n;
          c.className = 'pk__card ' + (d === 0 ? 'is-front' : 'is-' + (d + 1));
        });
      }
      // Sem troca automatica: o perk da frente muda so no clique (e ao passar o mouse, no computador).
      rows.forEach(function (r, k) {
        var btn = r.querySelector('.pk__btn');
        btn.addEventListener('click', function () {
          show(k);
        });
        if (hover) {
          btn.addEventListener('mouseenter', function () {
            show(k);
          });
        }
      });
      if (!reduced && window.matchMedia('(hover: hover)').matches) {
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5,
            y = (e.clientY - r.top) / r.height - 0.5;
          stage.classList.add('is-tilting');
          var f = stage.querySelector('.is-front');
          f.style.transform = 'rotateY(' + x * 10 + 'deg) rotateX(' + -y * 10 + 'deg) translate3d(0,0,0)';
        });
        stage.addEventListener('mouseleave', function () {
          stage.classList.remove('is-tilting');
          var f = stage.querySelector('.is-front');
          f.style.transform = '';
        });
      }
      show(0);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.pk').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
